import { CURRENCIES_WITH_THOUSAND_DIVISOR } from '../constants/currencies';
import { toFixed } from './toFixed';

export function formatAmountCentsBasedOnCurrency(
  amount: number | string,
  currency: string,
  isValidVisa = false
) {
  if (!amount) return '';

  const divisor = CURRENCIES_WITH_THOUSAND_DIVISOR.includes(currency) ? 1000 : 100;
  const updateAmount =
    typeof amount === 'string'
      ? parseFloat(amount.replace(/,/g, '')) * divisor
      : amount;
  const adjustedAmount = updateAmount / divisor;
  const cleanedAmount =
    isValidVisa && currency === 'OMR'
      ? Number(toFixed(adjustedAmount))
      : adjustedAmount;
  const decimals = CURRENCIES_WITH_THOUSAND_DIVISOR.includes(currency) ? 3 : 2;
  const formattedAmount = cleanedAmount.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return formattedAmount;
}
